import { useEffect } from 'react'

import { fullAgents, GOAgent } from '../utils/cards'
import { Step } from '../utils/steps'

import { useStep } from './use-step'

export const useAgents = (setAgents: (agents: typeof fullAgents) => void, agentsLength: number) => {
  const { step, setStep } = useStep()

  // wait for 2 seconds and show the full bench
  useEffect(() => {
    let timeout: NodeJS.Timeout
    if (step === Step.GrammarlyOnly) {
      timeout = setTimeout(() => {
        setAgents(fullAgents)
        setStep(Step.FullBench)
      }, 2000)
    } else if (step === Step.UseAgentSkillAnyWhere || step === Step.GoTime) {
      setAgents([GOAgent])
    } else if (agentsLength < 6) {
      setAgents(fullAgents)
    }

    return () => clearTimeout(timeout)
  }, [step, setStep, setAgents, agentsLength])
}
